var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalSourcesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.24,
    height: 78.719,
    viewBox: "0 0 74.24 78.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "totalSourcesIcon",
    transform: "translate(-480 -327.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11303",
    "data-name": "Path 11303",
    d: "M553.74,370.483a36.462,36.462,0,0,1-4.506,17.611c-.518.945-1.083,1.87-1.684,2.76a36.617,36.617,0,0,1-59.176,2.319c-.587-.745-1.152-1.518-1.684-2.312a36.639,36.639,0,0,1,0-40.757c.531-.794,1.1-1.566,1.684-2.312a36.617,36.617,0,0,1,59.176,2.319c.6.89,1.166,1.815,1.684,2.76A36.462,36.462,0,0,1,553.74,370.483Z",
    transform: "translate(0 -1.816)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12730",
    "data-name": "Group 12730",
    transform: "translate(486.69 328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11304",
    "data-name": "Path 11304",
    d: "M550.329,328v61.039a36.617,36.617,0,0,1-59.176,2.319c-.587-.745-1.152-1.518-1.684-2.312V328Z",
    transform: "translate(-489.47 -328)",
    fill: "rgba(var(--secondaryColorRGB) , 0.25)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5054",
    "data-name": "Rectangle 5054",
    width: 34.317,
    height: 16.567,
    transform: "translate(13.27 13.705)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_469",
    "data-name": "Line 469",
    x2: 34.317,
    transform: "translate(13.27 42.476)",
    fill: "none",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_470",
    "data-name": "Line 470",
    x2: 34.317,
    transform: "translate(13.27 57.916)",
    fill: "none",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11305",
    "data-name": "Path 11305",
    d: "M553.71,403.688a18.845,18.845,0,1,0-5.652,5.652l10.628,10.627,5.652-5.652Zm-23.518-2.533a10.848,10.848,0,1,1,15.341,0A10.839,10.839,0,0,1,530.192,401.155Z",
    transform: "translate(-11.936 -14.456)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSourcesIcon);
export default __webpack_public_path__ + "static/media/totalSourcesIcon.9d7f273d0c98d79d8a4e4d4c25a335f3.svg";
export { ForwardRef as ReactComponent };